import * as React from "react";
const SvgCheck = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12.08668 12.08668", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 12.08668, height: 12.08668, style: {
  fill: "none"
} }), /* @__PURE__ */ React.createElement("path", { d: "M11.23834,1.55938a.273.273,0,0,1,.438,0l.328.3a.4.4,0,0,1,.082.246.296.296,0,0,1-.082.219l-8.204,8.203a.30071.30071,0,0,1-.465,0l-3.253-3.254a.296.296,0,0,1-.082-.219.4.4,0,0,1,.082-.246l.328-.3a.26.26,0,0,1,.219-.11.26.26,0,0,1,.219.11l2.707,2.707,7.683-7.657Z", style: {
  fillRule: "evenodd"
} }));
export default SvgCheck;
